import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Stack,
  Button,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import api from "../services/api";

const NotificationsPage = () => {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPending = async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await api.get(
        "/customers/new-submissions",
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPending(data);
    } catch (err) {
      console.error("Failed to load new submissions:", err);
    } finally {
      setLoading(false);
    }
  };

  const markRead = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await api.patch(
        `/customers/${id}/mark-processed`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // remove from list
      setPending((p) => p.filter((c) => c.id !== id));
    } catch (err) {
      console.error("Failed to mark processed:", err);
    }
  };

  useEffect(() => {
    fetchPending();
  }, []);

  if (loading) return <Typography>Loading…</Typography>;

  return (
    <Box sx={{ pt: 10, px: 2, maxWidth: 600, mx: "auto" }}>
      <Typography variant="h5" gutterBottom>
        New Customer Submissions
      </Typography>
      {pending.length === 0 ? (
        <Typography>No new submissions.</Typography>
      ) : (
        <List>
          {pending.map((cust) => (
            <Paper key={cust.id} sx={{ mb: 2, p: 2 }}>
              <ListItem
                secondaryAction={
                    <Stack direction="row" spacing={1}>
                    <Button
                      component={RouterLink}
                      to={`/customers/${cust.id}`}
                      size="small"
                    >
                      View Details
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => markRead(cust.id)}
                    >
                      Mark read
                    </Button>
                  </Stack>
                }
              >
                <ListItemText
                  primary={`${cust.firstName} ${cust.lastName}`}
                  secondary={`Submitted ${cust.pets.length} pet(s)`}
                />
              </ListItem>
            </Paper>
          ))}
        </List>
      )}
    </Box>
  );
};

export default NotificationsPage;